module.exports = __webpack_public_path__ + "static/img/background.c2a72fd0.svg";